export default {
  winnfTs0122: 'WINNF-TS-0122'
};



// WEBPACK FOOTER //
// ./src/dictionaries/TestTypes.js